import { __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KFFilterFolderWrapper from '../Filters/FilterFolder/KFFilterFolderWrapper/index.js';
import FilterWrapper from '../Filters/FilterWrapper/index.js';

var KFFilterFolder = function (_a) {
    var filter = _a.filter, className = _a.className, expandIcon = _a.expandIcon, _b = _a.showElementCount, showElementCount = _b === void 0 ? true : _b, foldersAuthorized = _a.foldersAuthorized, onFilterUpdate = _a.onFilterUpdate, expanded = _a.expanded, setExpanded = _a.setExpanded, sx = _a.sx, KIcon = _a.KIcon, _c = _a.testId, testId = _c === void 0 ? "KFFilterFolder" : _c, _d = _a.id, id = _d === void 0 ? "KFFilterFolder" : _d, style = _a.style;
    var t = useTranslation("refront-components").t;
    var currentFolderId = filter && filter.values.length === 1 ? filter.values[0].id : undefined;
    var _e = useState(getFolderIdOnly(currentFolderId)), currentFolder = _e[0], setCurrentFolder = _e[1];
    var _f = useState(getFolderIdOnly(currentFolderId)), selectedFolder = _f[0], setSelectedFolder = _f[1];
    useEffect(function () {
        setCurrentFolder(getFolderIdOnly(currentFolderId));
        setSelectedFolder(getFolderIdOnly(currentFolderId));
    }, [currentFolderId]);
    var _g = useState(false), isFolderListVisible = _g[0], setIsFolderListVisible = _g[1];
    var onNavigate = function (folder) {
        setSelectedFolder(undefined);
        setCurrentFolder(folder);
        setIsFolderListVisible(true);
    };
    var onSelectFolder = function (selectedFolder) {
        var _a, _b;
        setCurrentFolder(selectedFolder);
        setSelectedFolder(selectedFolder);
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: [{ type: KpkFilterModifierType.EqualsOne, selected: true }], values: [
                {
                    id: selectedFolder.id,
                    label: (_a = String(selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.title)) !== null && _a !== void 0 ? _a : "",
                    title: (_b = String(selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.path)) !== null && _b !== void 0 ? _b : "",
                    selected: true
                },
            ] }));
    };
    return (React__default.createElement(FilterWrapper, { className: clsx("KFFilterFolder", className), filter: __assign(__assign({}, filter), { label: t("filter.advanced.folder.label") }), expanded: expanded, setExpanded: setExpanded, expandIcon: expandIcon, sx: sx, KIcon: KIcon },
        React__default.createElement(KFFilterFolderWrapper, { currentFolder: currentFolder, onNavigate: onNavigate, onSelectFolder: onSelectFolder, showElementCount: showElementCount, KIcon: KIcon, testId: testId, className: className, id: id, style: style, selectedFolder: selectedFolder, isFolderListVisible: isFolderListVisible, foldersAuthorized: foldersAuthorized })));
};
function getFolderIdOnly(currentFolderId) {
    return currentFolderId
        ? {
            id: currentFolderId
        }
        : undefined;
}

export { KFFilterFolder as default };
//# sourceMappingURL=index.js.map
